import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import 'reset.css'
import 'front/style.css'
import 'front/fonts.css'
import 'front/utils.css'

import CheckDevice from 'front/utils/CheckDevice.js'
import Router from 'front/Router.js'

import 'front/components/Footer/Footer.css'
import 'front/components/Hero/Hero.css'

import Parallax from 'front/components/Parallax/Parallax.js'
import BtnSide from 'front/components/BtnSide/BtnSide.js'
import BtnClose from 'front/components/BtnClose/BtnClose.js'
import BtnLoad from 'front/components/BtnLoad/BtnLoad.js'
import Frame from 'front/components/Frame/Frame.js'
import HeaderLink from 'front/components/HeaderLink/HeaderLink.js'
import IntroText from 'front/components/IntroText/IntroText.js'
import Person from 'front/components/Person/Person.js'
import LogoItem from 'front/components/LogoItem/LogoItem.js'

import Logo from 'front/components/Logo/Logo.js'
import Nav from 'front/components/Nav/Nav.js'
import ApplicationPopup from 'front/components/ApplicationPopup/ApplicationPopup.js'
import Langs from 'front/components/Langs/Langs.js'
import Cookie from 'front/components/Cookie/Cookie.js';


window.app.isRetina = false
CheckDevice.initialize()

window.app.router = new Router()

window.app.vent = _.extend({}, Backbone.Events)

window.app.els = {
    $window: $(window),
    $body: $('body'),
    $htmlBody: $('html,body'),
    $content: $('.Content')
}

window.app.views = {
    nav: new Nav(),
    applicationPopup: new ApplicationPopup(),
    langs: new Langs(),
    logo: new Logo(),
    cookie: new Cookie()
}

app.vent.on('page.loaded', window.app.loader.deactivate.bind(window.app.loader))

window.app.router.start()



// WEBPACK FOOTER //
// ./assets/app/front/App.js